export default __webpack_public_path__ + "static/media/order.81303e8f.png";